import { useEffect, useState } from 'react';

const mobileSearchModalQuery = '(max-width: 767px) and (orientation: portrait)';

const matchesMobileSearchModal = () =>
  typeof window !== 'undefined' &&
  window.matchMedia(mobileSearchModalQuery).matches;

const useMobileSearchModal = () => {
  const [isMobileSearchModal, setIsMobileSearchModal] = useState(
    matchesMobileSearchModal
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(mobileSearchModalQuery);
    let frame;

    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        setIsMobileSearchModal(mediaQuery.matches);
      });
    };

    update();
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', update);
    } else {
      mediaQuery.addListener(update);
    }

    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);

      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', update);
      } else {
        mediaQuery.removeListener(update);
      }
    };
  }, []);

  return isMobileSearchModal;
};

export default useMobileSearchModal;
